const ContextMapKeys = {
  FULL_EMAIL_ADDRESS: 'FULL_EMAIL_ADDRESS',
  OBJECT_TYPE_ID: 'OBJECT_TYPE_ID'
};
export default ContextMapKeys;